import Hero from "../components/sections/Hero";
import ChannelLogos from "../components/sections/ChannelLogos";
import Marquee from "../components/sections/Marquee";
import TVFan from "../components/sections/TVFan";
import Manifesto from "../components/sections/Manifesto";
import OwnedMedia from "../components/sections/OwnedMedia";
import Stats from "../components/sections/Stats";
import ServicesGrid from "../components/sections/ServicesGrid";
import Industries from "../components/sections/Industries";
import CaseStudies from "../components/sections/CaseStudies";
import Testimonials from "../components/sections/Testimonials";
import FAQ from "../components/sections/FAQ";
import CTA from "../components/sections/CTA";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <ChannelLogos />
      <TVFan />
      <Manifesto />
      <OwnedMedia />
      <Stats />
      <Marquee />
      <ServicesGrid />
      <Industries />
      <CaseStudies />
      <Testimonials />
      <FAQ />
      <CTA />
    </main>
  );
}
